export const groupBy = (list, field, arr = false) => {
  let data = list.reduce(function (rv, x) {
    (rv[x[field]] = rv[x[field]] || []).push(x);
    return rv;
  }, {});

  if (arr) {
    data = Object.values(data);
  }

  return data;
};

export const groupByKey = (list, field) => {
  let data = list.reduce(function (rv, x) {
    rv[x[field]] = x;
    return rv;
  }, {});
  return data;
};

export const makeSlug = (name) => {
  return makePlainText(name, "-");
};

export const makeKey = (name) => {
  return makePlainText(name, "_");
};

export const makePlainText = (name, delimiter) => {
  if (!name) {
    name = "";
  }
  return name
    .trim()
    .toLowerCase()
    .replace(/[ /&-]/g, delimiter) // replacing spaces, &, and - with the specified delimiter
    .replace(/[^\w]+/g, "") // removing special chars
    .replace(/[ /$@!;()*&%^/\\:{}-]+/g, delimiter) // replacing specified special chars and - with the delimiter
    .replace(/(_)\1+/gi, (str, match) => {
      // removing duplicate consecutive '_'
      return match[0];
    });
};

export const arrayUniqueByKey = (array, key) => {
  return [...new Map(array.map((item) => [item[key], item])).values()];
};

export const getTableDiffSummary = (
  oldData = [],
  newData = [],
  idField = "keyIndex",
  fields = []
) => {
  const oldRows = oldData || [];
  const newRows = newData || [];
  let fieldKeyObj = {};
  if (fields.length) {
    fields.map((e) => {
      fieldKeyObj[e.key] = e;
    });
  }

  const oldIds = new Set(oldRows.map((row) => row[idField]));
  const newIds = new Set(newRows.map((row) => row[idField]));

  const addedRows = newRows.filter((row) => !oldIds.has(row[idField]));
  const removedRows = oldRows.filter((row) => !newIds.has(row[idField]));

  const modifiedRows = [];
  const commonIds = [...new Set([...oldIds].filter((id) => newIds.has(id)))];

  commonIds.forEach((id) => {
    const oldRow = oldRows.find((row) => row[idField] === id);
    const newRow = newRows.find((row) => row[idField] === id);

    if (!deepEqual(oldRow, newRow)) {
      const changes = getChangedFields(oldRow, newRow);
      modifiedRows.push({
        id,
        changes,
        row: newRow,
        index: newRows.findIndex((row) => row[idField] === id) + 1,
      });
    }
  });

  // Generate summary text
  let summary = "";

  // 1. Added/Removed rows summary
  if (addedRows.length > 0) {
    summary += `<p>${addedRows.length} row(s) added</p>`;
  }

  if (removedRows.length > 0) {
    summary += `<p>${removedRows.length} row(s) removed</p>`;
  }

  // 2. Modified rows summary
  if (modifiedRows.length > 0) {
    summary += `${modifiedRows.length} row(s) modified:`;
    modifiedRows.forEach((row) => {
      summary += `<p>- Row ${row.index} changes:</p>`;

      Object.keys(row.changes.from).forEach((field) => {
        // const fromVal = row.changes.from[field];
        // const toVal = row.changes.to[field];

        // summary += `  • ${fieldKeyObj[field]?.label || field}: ${formatValue(fromVal)} → ${formatValue(
        //   toVal
        // )}\n`;

        if (fieldKeyObj[field]?.label) {
          summary += ` ${fieldKeyObj[field]?.label} , \n`;
        }
      });
    });
  }

  // If no changes
  if (!summary) {
    return "No changes detected between the tables.";
  }

  return summary;
};

// const formatValue = (value) => {
//   if (value === null) return "null";
//   if (value === undefined) return "undefined";
//   if (value === "") return '""';
//   if (typeof value === "object") return "[object]";
//   return String(value);
// };
export const deepEqual = (a, b) => {
  if (a === b) return true;

  // Handle Date objects
  if (a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }

  if (typeof a !== typeof b) return false;

  if (a && b && typeof a === "object") {
    if (Array.isArray(a) !== Array.isArray(b)) return false;

    if (Array.isArray(a)) {
      if (a.length !== b.length) return false;
      return a.every((val, i) => deepEqual(val, b[i]));
    }

    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every((key) => deepEqual(a[key], b[key]));
  }

  return false;
};
export const getChangedFields = (form1, form2) => {
  const changed = {
    from: {},
    to: {},
  };
  const allKeys = new Set([...Object.keys(form1), ...Object.keys(form2)]);

  allKeys.forEach((key) => {
    const val1 = form1[key];
    const val2 = form2[key];

    if (!deepEqual(val1, val2)) {
      changed.from[key] = val1;
      changed.to[key] = val2;
    }
  });
  return changed;
};

export const normalize = (obj) => {
  const copy = {};
  Object.keys(obj || {}).forEach((key) => {
    const val = obj[key];
    if (val !== "" && val !== null && val !== undefined) {
      copy[key] = val;
    }
  });
  return copy;
};

export const isValuesSame = (obj1, obj2) => {
  const n1 = normalize(obj1);
  const n2 = normalize(obj2);
  return JSON.stringify(n1) === JSON.stringify(n2);
}

export const isValueEmpty = (value) => {
  if (value === null || value === undefined) return true;
  if (typeof value === "string" && value.trim() === "") return true;
  if (Array.isArray(value) && value.length === 0) return true;
  if (typeof value === "object" && !Array.isArray(value) && Object.keys(value).length === 0) return true;
  return false;
};

